import React from "react";
import clsx from "clsx";
import { Box } from "@material-ui/core";
import { useDeviceTypes } from "halifax";

import styles from "./styles.module.scss";

export const ChfarImportantInformation = () => {
  const { matchesMobile } = useDeviceTypes();

  return (
    <Box
      className={clsx(styles["checkout-chfar-important-info-root"], {
        mobile: matchesMobile,
      })}
    >
      <Box>
        <Box className={styles["checkout-chfar-important-info-title-section"]}>
          Important Information
        </Box>
        <Box
          className={styles["checkout-chfar-important-info-terms-list"]}
          component="ol"
        >
          <li>
            By confirming this booking, your original flights will automatically
            be cancelled.
          </li>
          <li>
            You will be changing the itinerary for all passengers on your
            original booking. If you would like to apply changes only to a
            specific passenger, please give us a call at{" "}
            <a
              className={styles["checkout-chfar-important-info-tel"]}
              href="tel:844-422-6972"
            >
              844-422-6972
            </a>
            .
          </li>
          <li>
            Any paid add-ons from your original booking, including baggage,
            seats and the option to cancel for any reason, are not carried over
            to your new booking or reimbursed.
          </li>
          <li>
            If you customized your original booking with any extra service(s),
            the premium you paid to add them will be refunded to your original
            payment method. The services do not carry over and cannot be used on
            your new booking.
          </li>
        </Box>
      </Box>
    </Box>
  );
};
